/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {defaultsDeep} from 'lodash';

import {AbstractService} from '@amblique/base/shared/services/abstract-service';

/**
 * SFCC Storefront Service
 */
export class SFCCService extends AbstractService {
  /**
   * @returns {string}
   */
  static get name() {
    return 'SFCCService';
  }

  /**
   * @returns {object}
   */
  static get profile() {
    return defaultsDeep({
      baseUrl: '{origin}/mobify/proxy/sfcc/on/demandware.store/Sites-{site.id}-Site/{locale.id}',
      dynamicProperties: ['baseUrl'],
    }, super.profile);
  }

  /**
   * @inheritdoc
   *
   * @returns {string[]}
   */
  static get variables() {
    return ['origin', 'site', 'locale'];
  }

  /**
   * Gets public client data exposed by `Site-ClientData` controller
   *
   * @param {RequestInit} [request]
   *
   * @returns {Promise<{
   *  contents: object,
   *  preferences: object,
   *  resources: object,
   *  urls: object
   * }>}
   */
  async getClientData(request) {
    return this
      .get('Site-ClientData?format=json', request)
      .then((data) => data.clientData)
    ;
  }
}
